export const headerConfig = {
    phoneNumbers: [
        "03.89.42.87.34",
        "07.43.59.54.51"
    ],
    email: "contact@akte-immobilier.com"
};
